import { render } from "./SearchElementsRecentItems.vue?vue&type=template&id=3a80e632&scoped=true"
import script from "./SearchElementsRecentItems.vue?vue&type=script&lang=js"
export * from "./SearchElementsRecentItems.vue?vue&type=script&lang=js"

import "./SearchElementsRecentItems.vue?vue&type=style&index=0&id=3a80e632&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a80e632"]])

export default __exports__